import {
  type DefaultQueryError,
  type User,
  accountsUrl,
  apiRoutes,
  publicHttpClient,
} from '@ahm/api-wrappers-core';
import type { SupplierProfile } from './use-get-supplier-profile';

export type AuthSession = {
  token: string;
  refresh_token?: string;
  user?: User;
  supplier?: SupplierProfile;
};

export const getAuthSessionFn = async () => {
  try {
    const response = await publicHttpClient.get<AuthSession | null>(
      accountsUrl + apiRoutes.auth.internal.authSession,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    const errorData = (error as DefaultQueryError).response?.data;
    console.log('getAuthSessionFn error', errorData);
    return null;
  }
};
